import { useMemo } from 'react';

import { ModeConfig } from '../constants/modes';
import { selectConfig } from '../redux/context';
import { useAppSelector } from '../redux/hooks';
import Log from './Log';

const useLog = () => {
  const { logLevel }: ModeConfig = useAppSelector(selectConfig);
  return useMemo(() => new Log(logLevel), [logLevel]);
};

export default useLog;
